import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { FeatureContextService } from "@/_services/feature-context.service";
import { DateFormatService } from "@/_services/date-format/date-format.service";

@Component({
    selector: "app-root",
    encapsulation: ViewEncapsulation.None,
    styleUrls: ["app.component.scss", "../assets/css/core.scss"],
    templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
    title = "Preflight";

    constructor(
        private router: Router,
        // Injected to force eager initialization so context is set on first load
        _featureContext: FeatureContextService,
        _dateFormat: DateFormatService,
    ) {}

    ngOnInit() {
        if (navigator.userAgent.toLowerCase().includes("firefox")) {
            document.documentElement.classList.add("is-firefox");
        }

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (document.scrollingElement) {
                    document.scrollingElement.scrollTop = 0;
                }
            }
        });
    }
}
